import { Component, Input, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MessengerType } from '../core/models/messenger/MessengerToken';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-drive-app',
  templateUrl: './drive-app.component.html',
  styleUrls: ['./drive-app.component.scss'],
})
export class DriveAppComponent implements OnInit {
  @Input() action: string;
  @Input() access_code: string;
  @Input() data: string;
  @Input() messengerType: MessengerType;
  @Input() transportId: string;
  @Input() messengerUserId: string;
  @Input() driverName: string;

  init$ = new BehaviorSubject(false);
  googlePlayAppLink = environment.googlePlayApplication;
  appStoreAppLink = environment.appStoreApplication;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    if (this.action?.toLowerCase() === 'sign') {
      this.startMessengerSignature();
      return;
    }
    if (this.action?.toLowerCase() === 'sign_with_otp_for_counterparty') {
      this.startOtpCounterpartySignature();
    }
    this.init$.next(true);
  }

  startMessengerSignature(): void {
    const queryParams: Params = {
      accessCode: this.access_code,
      messengerType: this.messengerType,
      transportId: this.transportId,
      messengerUserId: this.messengerUserId,
      driverName: this.driverName
    };
    this.decodeUrlDataAndRedirect('/sign/messenger-signature', queryParams);
  }

  startOtpCounterpartySignature(): void {
    this.decodeUrlDataAndRedirect('/sign/otp-counterparty-signature');
  }

  private decodeUrlDataAndRedirect(url: string, queryParams: Params = {}) {
    if (this.data) {
      const data = JSON.parse(atob(this.data));
      queryParams = { ...queryParams, ...data };
    }
    this.router.navigate([url], { queryParams: queryParams });
  }

  isAndroid() {
    return /android/i.test(navigator.userAgent);
  }

  isIphone() {
    return /iPhone/i.test(navigator.userAgent);
  }
}
